import React, { FC, useEffect } from "react";
import { message, Modal } from "antd";
import useGlobalModel from "../../model/globalModel";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import { CLIENT_APP_CODE } from "@/utils/constants";
import { shopService, IVRMShopDetail } from "../organization/shop/shopService";
import { loginServiceAuth2, Auth2MenuDetail } from "./LoginServiceAuth2";
import { ToolOutlined, SmileTwoTone } from "@ant-design/icons";
import { globalPrompt } from "@/components/message";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { roleColumnModel } from "@/utils/roleColumn";
import "./config";

interface ITokenLogin {
	token: string;
}
declare const window: Window & { loginTimer: NodeJS.Timeout | null };

export const TokenLogin: FC<ITokenLogin> = ({ token }) => {
	const history = useHistory()
	const { user, shopAndOrg, setAllShopDs, setUser, setBeShopDs, setResourceAuth, setShopDs, setMenuAuth, setShopAndOrg } = useGlobalModel();
	const { queryRoleColumns } = roleColumnModel();

	useEffect(() => {
		if (!window.loginTimer) {
			window.loginTimer = setTimeout(function () { beforeLogin() }, 1500);
		}
	}, [])

	const beforeLogin = async () => {
		//初始页数
		const searchParams = { pageSize: -1, pageNum: 1 }
		let { retData } = await loginServiceAuth2.VerifyInfo({ sourceApp: sourceAppOrBranch.sourceApp, token });
		let { menus, resources, roles, shops, ...userInfo } = retData ?? {};

		//用户下没有站点或者站点信息不存在直接返回警告。
		if (!shops || !shops.length) {
			// loginServiceAuth2.Logout();
			message.warning("该用户下没有站点信息,请联系后台人员配置站点信息", 5);
			return;
		}
		setResourceAuth(resources ?? []);  //设置资源列表

		//设置用户菜单所有权限列表,(递归查询到所有要展示得菜单地址。)
		let menuArr: string[] = [];
		function findMenuAll(array: Auth2MenuDetail[]) {
			array.forEach(item => {
				item.linkUrl && menuArr.push(item.linkUrl);
				if (item.children && item.children.length > 0)
					findMenuAll(item.children);
			})
		}
		findMenuAll(menus?.[CLIENT_APP_CODE] ?? []);
		setMenuAuth(menuArr);

		//根据可视化配置处理需要展示相关列
		queryRoleColumns({ "roleCodes": roles });

		//设置用户站点信息
		let { retData: shopRetData } = await shopService.page({ page: searchParams, sourceApp: sourceAppOrBranch.sourceApp })
		const { records } = shopRetData;
		if (records && records.length > 0) {
			//拿到供应链所有的站点， 过滤出用户有权限的站点。
			let filterShop = records.filter(item => shops.indexOf(item.code) > -1 && item.status == 0);
			if (!filterShop.length) {
				// loginServiceAuth2.Logout();
				message.warning("该用户下没有配置vrm业务系统的站点信息");
				return;
			}

			setShopDs(filterShop.map(item => ({
				...item,
				key: item.id,
				label: item.name,
				value: item.id,
				code: item.code
			})));

			let filterlist = records.filter(item => item.status == 0);
			setAllShopDs(filterlist.map(item => ({
				key: item.id,
				label: item.name,
				value: item.id,
				code: item.code
			})))
			// let shop = filterShop[0]
			// setBeShopDs((shop?.details ?? []).map(item => ({
			// 	id: item.id,
			// 	label: item.bentityName ?? "",
			// 	value: item.bentityCode ?? ""
			// })))
			// setUser({ ...user, username: userInfo.userName, token, ...userInfo, loginType: 'account', shopCode: shop.code })
			// setShopAndOrg({ ...shopAndOrg, shopId: shop.id, shopName: shop.name, shopCode: shop.code })
			// globalPrompt("notification", {
			// 	type: "success", title: "登录成功",
			// 	duration: 3,
			// 	text: <p className="bold"><span className="block"><SmileTwoTone /> {`您好!${userInfo.userName ?? ""}`}</span>欢迎使用云豪云修管理系统</p>
			// });
			// loginServiceAuth2.recordAppLoginInfo(CLIENT_APP_CODE, userInfo.userCode);
			// history.push("/")

			let setShopModal = Modal.confirm({
				title: <span style={{ fontSize: "20px", fontWeight: "bold" }}>请选择你的站点</span>,
				centered: true,
				closable: true,
				icon: <ToolOutlined />,
				className: "login-shop-modal",
				content: <div className="login-shop-container">
					{
						filterShop.map(item => (
							<span key={item.id} onClick={() => setShopInfoOrUser(item)}>{item.name}</span>
						))
					}
				</div>,
				// onCancel: () => { loginServiceAuth2.Logout(); }
				onCancel: () => { message.warning("不选择站点信息将无法正常进入系统") }
			});

			const setShopInfoOrUser = async (shop: IVRMShopDetail) => {
				let { orgCode, orgName, type } = shop
				//默认设置用户第一个站点的信息 及站点下面对应的经营实体
				setBeShopDs((shop?.details ?? []).map(item => ({
					id: item.id,
					label: item.bentityName ?? "",
					value: item.bentityCode ?? ""
				})));
				const searchVal = { name: userInfo.userName, page: { pageSize: 10, pageNum: 1 }, sourceApp: "portal" }
				let { retData } = await shopService.getUser(searchVal);
				let orgType = ["user-type.employee"]
				if (orgType.includes(userInfo.userTypeCode)) {
					userInfo.orgType = 'in'
				} else {
					userInfo.orgType = 'out'
				}
				setUser({ ...user, username: userInfo.userName, token, ...userInfo, loginType: 'token', shopCode: shop.code, roles: roles, userOrgName: retData?.records[0]?.orgName, userOrgCode: retData?.records[0]?.orgCode, orgType: userInfo.orgType })
				setShopAndOrg({ ...shopAndOrg, shopId: shop.id, shopName: shop.name, shopCode: shop.code, shopType: type, orgCode, orgName })
				loginServiceAuth2.recordAppLoginInfo(CLIENT_APP_CODE, userInfo.userCode);
				globalPrompt("notification", {
					type: "success", title: "登录成功",
					duration: 3,
					text: <p className="bold"><span className="block"><SmileTwoTone /> {`您好!${userInfo.userName ?? ""}`}</span>欢迎使用蜘蛛网车服</p>
				});
				setShopModal.destroy();
				history.push("/")
			}
		}
	}

	return (
		<div className="login">
			<div className="caseBlanche">
				<div className="rond">
					<div className="test"></div>
				</div>
				<div className="load">
					<p>loading</p>
				</div>
			</div>
		</div>
	)

}

export default TokenLogin;